/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { UnsplashPhotoList, UsableUnsplashPhoto } from '../../../../shared/models/images/unsplash-images.model';
import { RestClientService } from '../../../../shared/services/rest-client.service';
import { ObservableResult } from '../../../../shared/store';
import { UnsplashImagesDataService, UnsplashOrientation } from './unsplash-images-data.service';

@Injectable()
export class ApiUnsplashImagesDataService implements UnsplashImagesDataService {
  constructor(
    private restClient: RestClientService,
    private translocoService: TranslocoService,
  ) {}

  search(phrase: string, page: number, orientation?: UnsplashOrientation): ObservableResult<UnsplashPhotoList> {
    let query = `cards/images/search?query=${phrase}&page=${page}`;
    if (orientation) {
      query = `${query}&orientation=${orientation}`;
    }
    return this.restClient.get<UnsplashPhotoList>(Location.joinWithSlash(environment.apiRootUrl || '', query)).pipe(
      switchMap(({ body }) => ObservableResult.ofSuccess(body)),
      catchError(() => ObservableResult.ofError(this.translocoService.translate('translations.errors.unableToLoadImage'))),
    );
  }

  download(url: string): ObservableResult<UsableUnsplashPhoto> {
    return this.restClient
      .post<UsableUnsplashPhoto>(Location.joinWithSlash(environment.apiRootUrl || '', 'cards/images/downloads'), { url: url })
      .pipe(
        switchMap(({ body }) => ObservableResult.ofSuccess(body)),
        catchError(() => ObservableResult.ofError(this.translocoService.translate('translations.errors.unableToLoadImage'))),
      );
  }
}
